<template>
    <div class="component-root">
        <h1>{{resource('JourneyBuilder_JourneyReport_Title')}}</h1>
        
        <!-- Button needs to be wrapped in a div to prevent it from stretching to full width -->
        <div><navigate-to-overview-button /></div>
        
        <configurable-sankey-v2 />
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import resourceMixin from "@core/Util/Mixins/resources";

    import {ConfigurableSankeyV2} from "@modules/JourneyBuilder/Components/Charts";
    import NavigateToOverviewButton from "@modules/JourneyBuilder/Components/Elements/NavigateToOverviewButton";
    
    const { mapState, mapMutations } = createNamespacedHelpers('journeyBuilder/reporting');

    export default {
        name: 'journey-statistics-overview',
        components: {
            NavigateToOverviewButton,
            ConfigurableSankeyV2
        },
        created() {
            const initialJourneyId = this.$route && this.$route.params.id;
            if(initialJourneyId){
                this.setJourneyId(initialJourneyId);
            }

            //Read highlightedBrickId from querystring
            const {highlightedBrickId: preSelectedBrickId} = (this.$route && this.$route.query) || {};
            
            //Preselect highlightedBrickId on initial dataset load
            if(preSelectedBrickId){
                this.setSelectedBrickId(preSelectedBrickId);   
            }
        },
        mixins: [resourceMixin],
        methods: {
            ...mapMutations(['setJourneyId', 'setSelectedBrickId'])
        },
        computed: {
            ...mapState(['sankeyData'])
        }
    }
</script>

<style scoped>
    .component-root {
        display: flex;
        flex-flow: column;
        row-gap: 10px;
    }
</style>